export class HeaderHeightCalculator {

    public getHeaderHeight(): number {
        const responsiveHeader = document.getElementById('responsiveHeader');
        if (!responsiveHeader) {
            return 0;
        }
        const headerHeight = responsiveHeader.clientHeight;
        return headerHeight;
    }
}

// Export fuer globales window object
if (typeof window !== 'undefined') {
    (window as any)['HeaderHeightCalculator'] = HeaderHeightCalculator;
}
